import {
	turnSelectors,
	levelSelectors,
	levelActions,
	turnActions,
	playerHealthSelectors,
	financialStatementsSelectors,
	gameSelectors
} from '~/store';
import { goToNextLevel } from '~/store/level/epic/goToNextLevel$';
import { hasMissionFailed, isMissionCompleted } from '~/store/level/helpers';
// ---- internal imports ----


export function handleEndOfQuarterLeveling(state) {
    return (dispatch, getState) => {
        const missions = levelSelectors.getMissions(state);
        const curTurnNum = turnSelectors.getTurnNum(state);

        const hasFailedMission = missions
            .find((mission) => (hasMissionFailed(state, mission)));

        if (hasFailedMission) {
            dispatch(levelActions.levelFailed());
        }

        const allMissionsCompleted = missions
            .every((mission) => (isMissionCompleted(mission, curTurnNum)));
        
        if (canGoToNextLevel(state, allMissionsCompleted)) {
            dispatch(goToNextLevel(getState()))
        }

        return;
    }
}

function canGoToNextLevel(state, allMissionsCompleted) {
	if (!allMissionsCompleted) {
		return false;
	}
	const hasEnoughHealth = playerHealthSelectors.getHealth(state) > 0;

	if (!hasEnoughHealth) {
		return false;
	}

	const hasEnoughCash = gameSelectors.getCash(state) >= 0;

	return hasEnoughCash;
}

export default handleEndOfQuarterLeveling;
